/**
 * 注意: 该组件为纯样式组件, 请勿写入业务逻辑
 */
import React from "react";
import { ListCardInfo } from "./components/ListCardInfo";
import { ListCardIcon } from "./components/ListCardIcon";
import { ListCardTools } from "./components/ListCardTools";
import styles from "./index.module.scss";
import { Tooltip } from "antd";

interface ListCardProps {
    title: string;
    children?: React.ReactNode;
}

function ListCard({ title, children }: ListCardProps) {
    return (
        <div className={styles.root}>
            <h1 className={styles.title}>
                <Tooltip title={title} placement="topLeft">
                    {title}
                </Tooltip>
            </h1>

            {children}
        </div>
    );
}

export { ListCard, ListCardInfo, ListCardIcon, ListCardTools };
